// extracted by mini-css-extract-plugin
module.exports = {"TermsAndConditions":"TermsAndConditions_TermsAndConditions__2tUtT"};